import { Component, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { AuthService } from './_core/services/auth.service';
import { Router } from '@angular/router';
import { SecretService } from './_core/services/secret.service';
import { getRouteNaming, shouldNavigateBack, getNavigateBackUrl } from './_core/utils/router.namings';
import { BackModalComponent } from './_shared/components/back-modal/back-modal.component';
import { LoadingService } from './_core/services/loading.service';
import { HelperService } from './_core/services/helper.service';
import { TopbarOrderService } from './_core/services/topbar-order.service';
import { Subscription } from 'rxjs';
import { APIService } from './_core/services/api.service';
import { NMaterialOrder } from '@ct-client';
import { SupplyStackToastrService, SupplyStackSidebar2Component } from '@slickss/supplystack-components';
import { OrderCreationTooltipService } from './_core/services/order-creation-tooltip.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CreditsModalComponent } from './_core/components/credits/credits.component';
import { OrderDetailRoutingService } from './_core/services/order-detail-routing.service';
import { TranslateService } from '@ngx-translate/core';
import { OOHService } from './_core/services/ooh.service';
import { environment } from 'src/environments/environment';
import { OrderCreationService } from './order/order-creation/services/order-creation.service';
import {MatMenu} from '@angular/material/menu';
import {MatIconRegistry} from '@angular/material/icon';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'supplystack-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnDestroy {
    @ViewChild('searchOrderMenu') searchOrderMenu: MatMenu;
    @ViewChild('sidebarDirective') sidebarDirective: SupplyStackSidebar2Component;

    private subscriptionList: Subscription[] = [];
    public appIcon: string;

    sidebarOptions = [
        {
            name: 'generic_home',
            icon: 'home',
            link: 'dashboard',
        },
        {
            name: 'generic_orders',
            icon: 'description',
            link: 'order/list',
        },
    ];

    noTopbarRoute = ['/', '/order/list', '/pdf', '/404', '/403'];

    noSidebarRoute = ['/pdf', '/404', '/403'];

    specialTopbarRoute = ['/order/detail/'];

    public searchForm: UntypedFormGroup;

    constructor(
        private authService: AuthService,
        private secretService: SecretService,
        private router: Router,
        private loadingService: LoadingService,
        private helperService: HelperService,
        private topbarOrderService: TopbarOrderService,
        private apiService: APIService,
        private toastrService: SupplyStackToastrService,
        private orderCreationTooltipService: OrderCreationTooltipService,
        private orderCreationService: OrderCreationService,
        private formBuilder: UntypedFormBuilder,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private orderDetailRoutingService: OrderDetailRoutingService,
        private oohService: OOHService,
        public dialog: MatDialog,
        public translate: TranslateService
    ) {
        if (window.location.host.includes('supplystack')) {
            this.loadingService.unsetMajorLoading();
            this.router.navigate(['redirect-page'], {
                queryParams: { callback: window.location.pathname + window.location.search },
            });
        }

        this.matIconRegistry.addSvgIcon(
            'app_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/app-icon.svg')
        );
        this.appIcon = 'app_icon';
        this.searchForm = this.formBuilder.group({ search: [''] });

        this.matIconRegistry.addSvgIcon(
            'palletized',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/palletized.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'adr',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/adr.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'temp-controlled',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/cold.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'parcel',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/parcel.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'part',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/part.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'load',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/load.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'collection-sched',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Collection.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'delivery-sched',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Delivery.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'created-sched',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Created.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'finished-sched',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Finished.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'approval-approved',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/approval-accepted.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'approval-pending',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/approval-pending.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'approval-rejected',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/approval-rejected.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'approval-default',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Finished.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'collection-fin',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Collection-fin.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'delivery-fin',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Delivery-fin.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'created-fin',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Created-fin.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'finished-fin',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/Finished-fin.svg')
        );

        this.translate.use('en');
    }

    public ngOnDestroy() {
        this.subscriptionList.forEach((s) => s.unsubscribe());
    }

    public loginEvent() {
        this.authService.loginNavigate();
    }

    public registerEvent() {
        this.router.navigate([`${this.secretService.getPortalID()}/account/request`]);
    }

    public logoEvent() {
        this.router.navigate([`${this.secretService.getPortalID()}`]);
    }

    public searchEvent(event) {
        this.fetchOrder(event);
    }

    public searchOrder(event) {
        this.fetchOrder(event);
    }

    public searchValue() {
        const searchInput = this.search;
        if (!searchInput.value) {
            searchInput.setErrors({ required: true });
            searchInput.markAsTouched();
            return;
        }
        searchInput.setErrors(null);
        this.fetchOrder(this.search.value);
    }

    public searchSidebarValue() {
        const sidebar = document.getElementsByClassName('sidebar-2')[0];
        if (sidebar) {
            const button: any = sidebar.getElementsByClassName('hamburguer-button')[0];
            if (button) {
                button.click();
            }
        }
        this.fetchOrder(this.search.value);
    }

    public addOrder() {
        this.router.navigate([
            `${this.secretService.getPortalID()}/${this.secretService.getOrderFlowVersion()}/order/create`,
        ]);
    }

    public get isSidebarOpened() {
        return this.helperService.getSidebarState();
    }

    public get mobileSidebarPresent() {
        return this.helperService.getMobileSidebarState();
    }

    public logout() {
        this.secretService.logout();
    }

    public credits() {
        this.dialog.open(CreditsModalComponent, { width: '456px' });
    }

    public profile() {
        window.location.href = `${environment.umsProfileUrl}?callback=${location.href}`;
    }

    private fetchOrder(orderCode: string) {
        const nDivID = this.secretService.getConfiguration().ctDivisionId;

        if (this.isSalesOrderMode) {
            this.subscriptionList.push(
                this.apiService
                    .getControlTowerOrderService()
                    .searchOrder(orderCode, nDivID, this.getEnvCode())
                    .subscribe(
                        () => {
                            this.router.navigate([`${this.secretService.getPortalID()}/order/detail/${orderCode}`]);
                        },
                        () => {
                            this.toastrService.openNotificationToastr(this.translate.instant('generic_order_not_found'), false);
                        }
                    )
            );
        } else {
            this.subscriptionList.push(
                this.apiService
                    .getControlTowerMaterialOrderService()
                    .searchOrder(orderCode, nDivID, this.getEnvCode())
                    .subscribe(
                        (order: NMaterialOrder) => {
                            if (!order) {
                                this.toastrService.openNotificationToastr(this.translate.instant('generic_order_not_found'), false);
                                return;
                            }
                            this.router.navigate([`${this.secretService.getPortalID()}/order/detail/${orderCode}`]);
                        },
                        () => {
                            this.toastrService.openNotificationToastr(this.translate.instant('generic_order_not_found'), false);
                        }
                    )
            );
        }
    }

    private getEnvCode() {
        return this.getConfiguration().ctEnvironment ? this.getConfiguration().ctEnvironment : 'default';
    }

    private getConfiguration(): any {
        return this.secretService.getConfiguration();
    }

    public openOrderSearchMenu() {
        this.searchOrderMenu.panelClass = this.isSidebarOpened ? 'opened-menu' : 'closed-menu';
    }

    public openSidebar() {
        this.helperService.setSidebarState(!this.isSidebarOpened);
        this.helperService.setMobileSidebarState(this.isSidebarOpened);
    }

    get isSpecialTopbar() {
        return !!this.specialTopbarRoute.find((s) => this.router.url.indexOf(s) >= 0);
    }

    get getOrderTitle() {
        return this.topbarOrderService.getOrder() ? this.topbarOrderService.getOrder() : Object.assign({});
    }

    get appLogo() {
        const emptyGif = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        if (!this.getSettings() || !this.getSettings().jStyles ) { return emptyGif; }
        if (!this.getSettings().jStyles.sLogoHorizontalUrl) { return emptyGif; }
        return this.getSettings().jStyles.sLogoHorizontalUrl;
    }

    public getOrderStatus(status: string) {
        return this.topbarOrderService.parseOrderStatus(status);
    }

    public getOrderStatusColor(status: string) {
        return this.topbarOrderService.parseOrderStatusColor(status);
    }

    public navigateBack() {
        const route = getNavigateBackUrl(this.router.url, this.orderDetailRoutingService);

        if (route) {
            if (route.hasModal) {
                this.openBackModal(`${this.secretService.getPortalID()}${route.backUrl}`);
            } else {
                this.router.navigate([`${this.secretService.getPortalID()}${route.backUrl}`]);
            }
        } else {
            this.router.navigate(['404']);
        }
    }

    public sidebarMobileNavigate(link) {
        const sidebar = document.getElementsByClassName('sidebar-2')[0];
        if (sidebar) {
            const button: any = sidebar.getElementsByClassName('hamburguer-button')[0];
            if (button) {
                button.click();
            }
        }
        this.sidebarNavigate(link);
    }

    public sidebarNavigate(link: string) {
        switch (link) {
            case 'dashboard':
                if (this.
                  router.
                  url.
                  indexOf(`${this.
                  secretService.
                  getPortalID()}/${this.
                  secretService.
                  getOrderFlowVersion()}/order/create`) >= 0) {
                    this.navigateDashboard();
                } else {
                    this.router.navigate([`${this.secretService.getPortalID()}/dashboard`]);
                }
                break;
            case 'order/list':
                if (this.
                  router.
                  url.
                  indexOf(`${this.
                  secretService.
                  getPortalID()}/${this.
                  secretService.
                  getOrderFlowVersion()}/order/create`) >= 0) {
                    this.navigateOrderList();
                } else {
                    this.router.navigate([`${this.secretService.getPortalID()}/order/list`]);
                }
                break;
            default:
                break;
        }
    }

    private navigateOrderList() {
        this.openBackModal(`${this.secretService.getPortalID()}/order/list`);
    }

    private navigateDashboard() {
        this.openBackModal(`${this.secretService.getPortalID()}/dashboard`);
    }

    public openBackModal(value) {
        const dialogRef = this.dialog.open(BackModalComponent, {
            width: '456px',
            data: {},
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                //this.orderCreationService.resetCounters();
                this.router.navigate([value]);
            }
        });
    }

    public onActivate() {
        window.scroll(0, 0);
    }

    private getSettings(): any {
        return this.secretService.getPortalSettings() ? this.secretService.getPortalSettings() : null;
    }

    get isOrderCreation() {
        return this.router.url.indexOf('order/create/') >= 0;
    }

    get isDashboard() {
        return this.router.url.indexOf('/dashboard') >= 0;
    }

    get search() {
        return this.searchForm.get('search');
    }

    public canNavigateBack(): boolean {
        return shouldNavigateBack(this.router.url);
    }

    public toggleTooltips() {
        this.orderCreationTooltipService.changeTooltip();
    }

    get tooltipEnabled() {
        return this.orderCreationTooltipService.tooltipEnabled();
    }

    get loggedUser() {
        const user = this.secretService.getUser();
        return user
            ? {
                  name: user.name,
                  email: user.email,
                  profilePicture: user.pictureUrl,
              }
            : null;
    }

    get topbarNaming(): string {
        return getRouteNaming(this.router.url) ? this.translate.instant(getRouteNaming(this.router.url).name) : '';
    }

    get isLoading() {
        const pageWrapper = document.getElementsByClassName('page-wrapper')[0];
        if (!this.helperService.hasPageWrapper() && !this.loadingService.isMajorLoading && !!pageWrapper) {
            this.helperService.setPageWrapper(pageWrapper);
        }

        return this.loadingService.isMajorLoading;
    }

    public navigatePdf() {
        window.open(
            `${location.origin}/${this.secretService.getPortalID()}/order/detail/${
                this.topbarOrderService.getOrder().sSalesOrderCode
            }/pdf`,
            '_blank'
        );
    }

    get sidebarActive() {
        return !!this.secretService.getToken() && this.isUserAllowed && this.isSidebarRoute;
    }

    get isUserAllowed() {
        const user = this.secretService.getUser();
        return !!user && !!this.secretService.getConfiguration()
            ? !!user.portalConfigs.find((p) => p.type === 'CP' && p.name === this.secretService.getConfiguration().configId)
            : false;
    }

    get isOrderCreationEnabled() {
        return this.isMaterialOrderMode ? this.getSettings().bOrderCreation : this.isOOHAndOrdersEnabled;
    }

    get isOOHAndOrdersEnabled() {
        return this.oohService.isOOH()
            ? !!this.oohService.isOOH() && !!this.getSettings() && this.getSettings().bOutOfficeHoursCreateOrder
            : true;
    }

    public mobileShowSidebar() {
        this.helperService.setMobileSidebarState(!this.mobileSidebarPresent);
        this.helperService.setSidebarState(this.mobileSidebarPresent);
    }

    get isRegisterActive() {
        return !!this.getSettings() && this.getSettings().bAccountRegistration;
    }

    get sidebarOpened() {
        return this.isSidebarOpened && this.sidebarActive;
    }
    get loginTopbarActive() {
        return !this.secretService.getToken() && !!this.secretService.getConfiguration();
    }
    get normalTopbarActive() {
        return !!this.secretService.getToken() && this.isTopbarRoute && !!this.isUserAllowed;
    }
    get isSidebarRoute() {
        return !this.noSidebarRoute.filter((route) => this.router.url.indexOf(route) >= 1).length && this.router.url !== '/';
    }
    get isTopbarRoute() {
        return (
            !this.noTopbarRoute.filter((route) => this.router.url.indexOf(route) >= 1).length &&
            this.router.url !== '/' &&
            this.router.url !== `/${this.secretService.getPortalID()}` &&
            this.router.url !== `/${this.secretService.getPortalID()}/`
        );
    }

    private getCreationCurrentMode() {
        const settings: any = this.secretService.getPortalSettings();
        return settings ? settings.sOrderLogic : null;
    }

    public get isMaterialOrderMode() {
        return this.getCreationCurrentMode() === 'MATERIAL_ORDER';
    }

    public get isSalesOrderMode() {
        return this.getCreationCurrentMode() === 'SALES_ORDER';
    }
}
